import { render, staticRenderFns } from "./_.vue?vue&type=template&id=a3d3bada&"
import script from "./_.vue?vue&type=script&lang=ts&"
export * from "./_.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,BlogTagArticles: require('/home/vsts/work/1/a/NuxtApp/components/blog/TagArticles.vue').default,BlogLayout: require('/home/vsts/work/1/a/NuxtApp/components/blog/Layout.vue').default})
